import React from "react";
import WIPNotificationsComponent from "./wipNotifications.component";

const NotificationsComponent = ({ type }) => {
  // For supplier-facing-platform, we only have WIP notifications
  if (type === "wip") {
    return <WIPNotificationsComponent />;
  }

  // Default to WIP notifications
  return <WIPNotificationsComponent />;
};

export default NotificationsComponent;

